<template>
  <div class="region">
    <div class="procedure">
      <div class="procedure-title">
        <h3>{{info.title}}</h3>
      </div>
      <div class="procedure-content">
        <div class="tabs-control" :class="{'en': info.language == 'en'}">
          <ul>
            <li v-for="(item, index) in info.tabsControl" :key="index" @click="tabClick(index)" :class="{'active':index == num}">{{item}}</li>
          </ul>
          <div class="down-btn">
            <a class="download" :href="`${publicPath}${downloadhref}`" target="_blank" download v-if="downloadshow">
              <i></i> {{info.downloadTitle}}
            </a>
          </div>
        </div>
        <div class="tabs-item" v-if="info.language == 'cn'">
         <div v-show="0 == num" style="width:100%;">
            <img style="width:100%;" src="~img/internetCourt/bj_lc_img_ch.gif" alt />
          </div>
          <div v-show="1 == num" style="width:100%;">
            <img style="width:100%;" src="~img/internetCourt/hz_lc_img_ch.gif" alt />
          </div>
          <div v-show="2 == num" style="width:100%;">
            <img style="width:100%;" src="~img/internetCourt/gz_lc_img_ch.png" alt />
          </div>
        </div>
        <div class="tabs-item" v-else>
         <div v-show="0 == num" style="width:100%;">
            <img style="width:100%;" src="~img/internetCourt/bj_lc_img.gif" alt />
          </div>
          <div v-show="1 == num" style="width:100%;">
            <img style="width:100%;" src="~img/internetCourt/hz_lc_img.gif" alt />
          </div>
          <div v-show="2 == num" style="width:100%;">
            <img style="width:100%;" src="~img/internetCourt/gz_lc_img.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: 0,
      publicPath: process.env.BASE_URL,
      tabhead: ["北京互联网法院", "杭州互联网法院诉讼平台", "广州互联网法院"],
      itemCon: [],
      downloadhref:"template/北京互联网法院帮助文档.pdf",
      downloadshow: true,
      language: 'en',
    };
  },
  props: ['info'],
  methods: {
    tabClick(index) {
      // console.log(index)
      index == 0? this.downloadhref = 'template/北京互联网法院帮助文档.pdf':index == 1?this.downloadhref = 'template/杭州互联网法院诉讼平台帮助文档.pdf':this.downloadhref = 'template/广州互联网法院帮助文档.pdf'
      this.num = index;
      // console.log(this.downloadhref)
    }
  }
};
</script>
<style lang="scss" scoped>
.region {
  width: 100%;
  .procedure {
    width: 100%;
    margin: 0 auto;
    &-title {
      text-align: center;
      padding: 30px 0;
      font-size: 24px;
      color: #333333;
    }
    &-content {
      .tabs {
        &-control {
          position: relative;
          height: 46px;
          border-bottom: 1px #ccc solid;
          ul {
            width: 712px;
            height: 60px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
            li {
                font-size: 16px;
                height: 46px;
                line-height: 46px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding: 0px 17px;
                color: #646464;
                cursor: pointer;
              &.active {
                color: #323232;
                border-bottom: 2px solid #0A57C9;
              }
            }
          }
          .down-btn{
            width: 1200px;
            margin: 0 auto;
            height: 20px;
            text-align: right;
          }
          .download {
            color: #0088FE;
            i {
              
              display: inline-block;
              width: 15px;
              height: 15px;
              vertical-align: middle;
              background: url("~img/internetCourt/down_hlwfy_nor_icon.png") center
                no-repeat;
                background-size: contain;
            }
            &:hover {
              color: #0A57C9;
              i {
                background: url("~img/internetCourt/down_hlwfy_hov_pre_icon.png")
                  center no-repeat;
                  background-size: contain;
              }
            }
          }
          &.en {
            ul {
              width: 758px;
            }
          }
        }
        &-item {
          padding: 20px 0;
          width: 1200px;
          margin: 0 auto;
          margin-top: 25px;
        }
      }
    }
  }
}
</style>
